export default __webpack_public_path__ + "static/media/explore4.556556ec.png";